import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./AboutUs.scss";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../shared/custom-button/custom-button";
import { NavLink } from "react-bootstrap";
// import "../../../../public/images/home/home-about.webp"

const ArrowLeft = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ArrowRight = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const AboutUs = () => {
  const sliderRef = useRef(null);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const navigate = useNavigate();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    cssEase: "linear",
    adaptiveHeight: true,
  };

  const goToNext = () => sliderRef.current.slickNext();
  const goToPrev = () => sliderRef.current.slickPrev();

  return (
    <section className="about-us-carousel-section">
      <div className="container">
        <Slider ref={sliderRef} {...settings}>
          {/* Slide 1: About Us */}
          <div className="slide-container">
            <div className={`about-slide ${isExpanded ? "expanded" : ""}`}>
              <div className="about-content">
                <span className="subtitle">About Us</span>
                <h2 className="title">Growth Through Strategic Advisory</h2>
                <div className="about-image-column mobile-image">
                  <div className="image-wrapper">
                    <img src="/images/home/home-about.webp" alt="About Us" />
                  </div>
                  <div className="caption">
                    Advisors to leadership teams when decisions matter most.
                    Respected for judgment. Valued for outcomes.
                  </div>
                </div>
                <div className="desc-wrapper">
                  <div className="spacer"></div>
                  <div className="description">
                    <p>
                      Amicus Growth Advisors is a Mumbai-based boutique
                      management consulting and advisory firm that works closely
                      with promoters, founders, and leadership teams to solve
                      complex business challenges and build scalable,
                      profitable, and institutionally strong organizations. We
                      partner with clients at critical inflection points where
                      clarity of strategy, execution discipline, and capital
                      efficiency are essential to achieving sustainable growth.
                    </p>
                    {!isExpanded ? (
                      <>
                        <p>
                          Our work spans the full business lifecycle, from
                          business diagnostics to enterprise-wide transformation
                          and value creation. We support organizations through
                          enterprise profitability transformation, cost
                          optimization, go-to-market strategy design,
                        </p>
                        <span
                          className="read-more"
                          onClick={() => setIsExpanded(true)}
                        >
                          Read More
                        </span>
                      </>
                    ) : (
                      <>
                        <p>
                          Our work spans the full business lifecycle, from
                          business diagnostics to enterprise-wide transformation
                          and value creation. We support organizations through
                          enterprise profitability transformation, cost
                          optimization, go-to-market strategy design, structured
                          monthly review mechanisms, and SOP-driven process
                          institutionalization. Our services also include
                          business transformation programs, CFO services, IPO
                          project management, feasibility and strategy reports,
                          startup advisory, and fund advisory covering financial
                          due diligence, valuation and deal structuring,
                          investor deck preparation, and pre- and post-deal
                          support. In parallel, our transaction advisory
                          practice supports mergers and acquisitions as well as
                          fund-raising mandates, complemented by a strong human
                          capital offering across KRA and KPI design,
                          performance management systems, leadership and people
                          development, learning and development frameworks, and
                          culture-building initiatives.
                        </p>
                        <p>
                          Amicus Growth Advisors is led by its founder Sanjeev
                          Jain, a seasoned finance and strategy leader with
                          extensive experience across listed and multinational
                          organizations. He has previously served as CFO at Gati
                          Limited and FedEX, and has held senior leadership
                          roles across multiple companies, bringing deep
                          expertise in finance, governance, capital markets, and
                          large-scale business transformation. Under his
                          leadership, Amicus operates as an extended arm of
                          management, combining analytical depth with hands-on
                          execution to help organizations build resilient
                          businesses, attract institutional capital, and create
                          long-term value with confidence and discipline.
                        </p>
                        <span
                          className="read-more"
                          onClick={() => setIsExpanded(false)}
                        >
                          Show Less
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="about-image-column desktop-image">
                <div className="image-wrapper">
                  <img src="/images/home/home-about.webp" alt="About Us" />
                </div>
                <div className="caption">
                  Advisors to leadership teams when decisions matter most.
                  Respected for judgment. Valued for outcomes.
                </div>
              </div>
            </div>
          </div>

          {/* Slide 2: Experience */}
          <div className="slide-container">
            <div className="experience-slide">
              <div className="experience-container">
                <h2 className="title">
                  Our Experience <br /> Spans
                </h2>
                <div className="exp-item top-left">
                  <div className="icon-wrapper blue">
                    <img
                      src="/images/home/aboutus/sme-ipo.webp"
                      alt="SME IPO preparation"
                    />
                  </div>
                  <span className="label">SME IPO preparation</span>
                </div>
                <div className="exp-item top-right">
                  <div className="icon-wrapper grey">
                    <img
                      src="/images/home/aboutus/growth-state.webp"
                      alt="Growth-stage fundraising"
                    />
                  </div>
                  <span className="label">Growth-stage fundraising</span>
                </div>
                <div className="exp-item bottom-left">
                  <div className="icon-wrapper light-orange">
                    <img
                      src="/images/home/aboutus/financial-planning.webp"
                      alt="Financial planning"
                    />
                  </div>
                  <span className="label">Financial planning</span>
                </div>
                <div className="exp-item bottom-right">
                  <div className="icon-wrapper orange">
                    <img
                      src="/images/home/aboutus/governance-frameworks.webp"
                      alt="Governance frameworks"
                    />
                  </div>
                  <span className="label">Governance frameworks</span>
                </div>
              </div>
            </div>
          </div>

          {/* Slide 3: Support */}
          <div className="slide-container">
            <div className="support-slide">
              <div className="support-content-wrapper">
                <div className="left-side">
                  <h2 className="title">
                    We Support <br /> Businesses That Are:
                  </h2>
                </div>
                <div className="right-side">
                  <div className="boxes-row">
                    <div className="support-box light-orange">
                      <div className="bg-icon">
                        <img
                          src="/images/home/aboutus/growth-oriented.webp"
                          alt="Growth Oriented"
                        />
                      </div>
                      <span className="text">Growth Oriented</span>
                    </div>
                    <div className="support-box blue elevated">
                      <div className="bg-icon">
                        <img
                          src="/images/home/aboutus/entering-new-markets.webp"
                          alt="Entering new markets"
                        />
                      </div>
                      <span className="text">Entering new markets</span>
                    </div>
                    <div className="support-box light-orange">
                      <div className="bg-icon">
                        <img
                          src="/images/home/aboutus/seeking-capital.webp"
                          alt="Seeking capital"
                        />
                      </div>
                      <span className="text">Seeking capital</span>
                    </div>
                  </div>
                  <div className="button-wrapper">
                    <CustomButton
                      onClick={() => {
                        navigate("/company");
                      }}
                      variant="primary"
                    >
                      Know More About Us
                    </CustomButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>

        <div className="carousel-header">
          <div className="nav-arrows">
            <div className="arrow prev" onClick={goToPrev}>
              <ArrowLeft />
            </div>
            <div className="arrow next" onClick={goToNext}>
              <ArrowRight />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
